import React from 'react';
import InfoPage, { Section } from '../components/InfoPage';
import { STORY_IMAGE, STORY_IMAGE_2 } from '../mock';

const OurStory = () => (
  <InfoPage
    title="Our Story"
    subtitle="Hair care that respects your intelligence, your time, and your budget."
  >
    <img src={STORY_IMAGE} alt="K-Root" className="w-full rounded-2xl" />

    <Section heading="It started with one frustrated mirror moment">
      <p>
        K-Root was born after years of trying products that promised the world and delivered nothing but greasy pillows.
        We wanted a hair-loss ritual that was natural, effective, and didn't require a complicated routine or a $100 monthly subscription.
        That product didn't exist, so we made it.
      </p>
    </Section>

    <Section heading="The Korean scalp-first philosophy">
      <p>
        Western hair care treats your hair. Korean hair care treats your scalp. We partnered with Korean formulators who have
        spent decades studying fermented herbs and how they interact with the follicle. The result is a 60-second shower ritual
        that targets the root cause of thinning hair, not the symptom.
      </p>
    </Section>

    <img src={STORY_IMAGE_2} alt="K-Root lifestyle" className="w-full rounded-2xl" />

    <Section heading="Every ingredient is intentional">
      <p>
        We chose 12 fermented herbs over fancy synthetics. We chose a solid bar over a watered-down liquid. We chose less plastic,
        less waste, and less BS. If you can't pronounce it, it's not in the bar.
      </p>
    </Section>

    <Section heading="What we promise">
      <p>— Honesty. We won't tell you it works in 24 hours because it doesn't.</p>
      <p>— Quality. Every batch is tested before it leaves the lab.</p>
      <p>— Support. If it isn't working for you, our team will work with you to make it right.</p>
    </Section>
  </InfoPage>
);

export default OurStory;
